import { FormattedMessage } from "react-intl";
import { VisuallyHidden } from "radix-ui";

export type HotelNameProps = {
	name: string;
	/** Hotel stars, shown after the name and spelled out for assistive technologies. Hidden at 0. */
	category?: number;
};

/** Hotel name followed by its stars, e.g. "Arlo Midtown 4*". */
export const HotelName = ({ name, category = 0 }: HotelNameProps) => (
	<>
		{name}
		{category > 0 && (
			<>
				{" "}
				<span aria-hidden="true">
					{category}
					<sup>*</sup>
				</span>
				<VisuallyHidden.Root>
					<FormattedMessage
						id="product.card.category.label"
						values={{ count: category }}
					/>
				</VisuallyHidden.Root>
			</>
		)}
	</>
);
